export default __webpack_public_path__ + "static/media/support2.1a9792ff.jpg";